//Order Filter
export const ORD_FROM_DATE = "created_date__from";
export const ORD_TO_DATE = "created_date__to";

export const PMT_FROM_DATE = "payment_date__from";
export const PMT_TO_DATE = "payment_date__to";

//User Filter
export const USER_FROM_DATE = "created_date__from";
export const USER_TO_DATE = "created_date__to";

//User PSP  Filter
export const PSP_FROM_DATE = "created_date__from";
export const PSP_TO_DATE = "created_date__to";
//User PSP Mapping Filter
export const PSP_Mapping_FROM_DATE = "created_date__from";
export const PSP_Mapping_TO_DATE = "created_date__to";

//User AG Mapping Filter
export const AG_Mapping_FROM_DATE = "created_date__from";
export const AG_Mapping_TO_DATE = "created_date__to";

//User Product Mapping Filter
export const PRODUCT_Mapping_FROM_DATE = "created_date__from";
export const PRODUCT_Mapping_TO_DATE = "created_date__to";

//Role Filter
export const ROL_FROM_DATE = "created_date__from";
export const ROL_TO_DATE = "created_date__to";

export const AG_FROM_DATE = "created_date__from";
export const AG_TO_DATE = "created_date__to";

export const AGM_FROM_DATE = "created_date__from";
export const AGM_TO_DATE = "created_date__to";

export const AGFM_FROM_DATE = "created_date__from";
export const AGFM_TO_DATE = "created_date__to";

export const ORG_FROM_DATE = "created_date__from";
export const ORG_TO_DATE = "created_date__to";

export const PPET_FROM_DATE = "created_date__from";
export const PPET_TO_DATE = "created_date__to";

export const OEM_FROM_DATE = "created_date__from";
export const OEM_TO_DATE = "created_date__to";

export const IP_FROM_DATE = "created_date__from";
export const IP_TO_DATE = "created_date__to";

export const RPT_FROM_DATE = "created_date__from";
export const RPT_TO_DATE = "created_date__to";
